<template>
    <div style="width: 200px;">
        <div class="ex-connection-tag mb-5" v-if="model[index] === 0">{{ $t('integration.abnormal_connection') }}</div>
        <div class="ex-data-tag mb-5" v-if="model[index] === 1">{{ $t('integration.abnormal_data') }}</div>
        <div class="ex-power-tag mb-5" v-if="model[index] === 2">{{ $t('integration.abnormal_power_failure') }}</div>
    </div>
</template>

<script>
export default {
    props: ['model', 'index']
};
</script>

<style></style>
